import React from 'react'
import { CZDeck } from './CZDeck'
import { CZTabla } from './CZTabla'


export const CZContenedor = ({czs, deck, prog, resetEstado}) => {
    return (
        <div className="contenedor">
            {
                deck?
                (
                    <CZDeck czs={czs} programa={prog} resetEstado={resetEstado} />
                ) :
                (
                    <CZTabla czs={czs} programa={prog} resetEstado={resetEstado} />
                )
            }
        </div>
    )
}